<template>
	<div class="d-flex flex-column flex-grow-1 overflow-hidden my-2">
		<v-sheet
			outlined
			rounded
			class="visible-all-users d-flex align-center flex-grow-0 flex-shrink-0 px-4 py-2 mb-3"
		>
			<v-switch
				class="mt-0 pt-0 pl-1 flex-grow-0"
				hide-details
				dense
				:disabled="!canEdit"
				v-model="visibleAllUsers"
				label="Visible to all users"
				@change="onVisibleAllUsersChanged"
			/>
			<v-icon small class="ml-6 mr-2" :color="hintColor">{{
				hintIcon
			}}</v-icon>
			<span class="caption text--secondary">{{ hint }}</span>
		</v-sheet>
		<assign-user />
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import AssignUser from './AssignUser.vue';
import { FormDetailsGetters } from '../../../../store/getters';
import { FormDetailsActions } from '../../../../store/actions';
import { Permissions } from '../../../../enums/permissionsEnum';
import permissionsMixin from '../../../../mixins/permissionsMixin';
export default {
	name: 'InventoryFormAssignUsers',
	mixins: [permissionsMixin],
	data() {
		return {
			visibleAllUsers: false,
		};
	},
	computed: {
		...mapGetters({
			selectedForm: [FormDetailsGetters.SELECTEDFORM],
		}),
		canEdit() {
			return this.hasPermissions([Permissions.Tools.FormBuilder.Edit]);
		},
		hint() {
			return this.visibleAllUsers
				? 'Everyone in the project can see this form, no matter which users are assigned below.'
				: 'Only the users assigned below can see this form.';
		},
		hintIcon() {
			return this.visibleAllUsers
				? 'mdi-account-group'
				: 'mdi-account-check';
		},
		hintColor() {
			return this.visibleAllUsers ? 'info' : '';
		},
	},
	watch: {
		selectedForm: {
			immediate: true,
			handler(value) {
				this.visibleAllUsers = !!(value && value.VisibleAllUsers);
			},
		},
	},
	methods: {
		onVisibleAllUsersChanged() {
			if (!this.selectedForm) return;
			let form = Object.assign({}, this.selectedForm, {
				VisibleAllUsers: this.visibleAllUsers,
			});
			this.$store
				.dispatch(FormDetailsActions.UPDATE_INVENTORYFORMS, form)
				.then((success) => {
					if (!success) this.visibleAllUsers = !this.visibleAllUsers;
				});
		},
	},
	components: { AssignUser },
};
</script>
